/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Listen_In_SchoolInputs */

const en_homepage_listen_in_school = /** @type {(inputs: Homepage_Listen_In_SchoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At School`)
};

const es_homepage_listen_in_school = /** @type {(inputs: Homepage_Listen_In_SchoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En la escuela`)
};

/**
* | output |
* | --- |
* | "At School" |
*
* @param {Homepage_Listen_In_SchoolInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_listen_in_school = /** @type {((inputs?: Homepage_Listen_In_SchoolInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Listen_In_SchoolInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_listen_in_school(inputs)
	return en_homepage_listen_in_school(inputs)
});